import axios from "axios";

export const api = axios.create({
  baseURL: "https://mtkqsyeao5.execute-api.us-east-1.amazonaws.com/",
});
